/*
 * @Description: echart根节点
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-19 14:14:21
 * @LastEditTime: 2021-01-20 14:40:04
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import ReactEcharts from 'echarts-for-react'
// @ts-ignore
import s from './ExportEcharts.css';

class ExportEcharts extends React.Component {

  shouldComponentUpdate(nextProps) {
    return nextProps.option !== this.props.option
  }
  
  echartStyle = () => {
    return {
      width: '100%',
      height: '100%'
    }
  }

  clear = () => {
    this.instance.echartsInstance.clear()
  }

  render () {
    const option = this.props.option;

    if (option.clear && this.instance && this.instance.getEchartsInstance) {
      const instance = this.instance.getEchartsInstance()
      instance.clear()
    }
    if (option.dispose && this.instance && this.instance.getEchartsInstance) {
      const instance = this.instance.getEchartsInstance()
      instance.dispose()
    }
    return ( <ReactEcharts option={option} ref={res => { this.instance = res}} style={this.echartStyle()}></ReactEcharts> );
  }
}

export default withStyles(s)(ExportEcharts);


// WEBPACK FOOTER //
// src/components/ExportEcharts/ExportEcharts.js